import React, { FC } from "react";
import { IoIosArrowDown as DownArrow } from "@react-icons/all-files/io/IoIosArrowDown";
import { RiCalendarEventFill as CalendarIcon } from "@react-icons/all-files/ri/RiCalendarEventFill";
import { VscTasklist as ClassIcon } from "@react-icons/all-files/vsc/VscTasklist";
import styles from "./planOverhang.module.scss";
import { IPlanOverhang } from "./IPlanOverhang";
import { usePlanOverhang } from "./usePlanOverhang";

// Kept here so it is easy to add it in the body at two places, depending on the device type
const PlanOverhang: FC<IPlanOverhang.IProps> = props => {
    const { listingIsClass, classText, planText, onClick } =
        usePlanOverhang(props);

    return (
        <div className={styles.scheduleOverhang} onClick={onClick}>
            <CalendarIcon className={styles.textIcon} />
            <div className={styles.scheduleOverhangItem}>{planText}</div>
            <DownArrow className={styles.downArrow} />
            {listingIsClass && (
                <>
                    <div className={styles.overhangDivider} />
                    <ClassIcon className={styles.textIcon} />
                    <div className={styles.scheduleOverhangItem}>
                        {classText}
                    </div>
                    <DownArrow className={styles.downArrow} />
                </>
            )}
        </div>
    );
};
export default PlanOverhang;
